<template>
  <div class="grid">
    <div class="grid-cell">
      <div :style="{fontSize: '18px', paddingTop: '20px'}">{{resultJson.student.number}} {{resultJson.student.name}}</div>
    </div>
    <div class="grid-cell-300">
      <!-- MEMO: 2018のみ -->
      <div v-if="isApp2018" class="grid result-grid">
        <div class="grid-cell result-cell">
          <div>必修・選択科目</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div>{{resultJson.total.total - resultJson.total.free}} / {{specBorder.total - specBorder.freeTotal}}</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="required" :style="getJudgementStyle(requiredTotalJudgementValue)">{{requiredTotalJudgementValue}}</div>
        </div>
      </div>
      
      <!-- MEMO: 2019のみ -->
      <div v-if="isApp2019" class="grid result-grid">
        <div class="grid-cell result-cell">
          <div>必修科目</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div>{{resultJson.total.must}} / {{specBorder.mustTotal}}</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="required" :style="getJudgementStyle(mustTotalJudgementValue)">{{mustTotalJudgementValue}}</div>
        </div>
      </div>
      <!-- MEMO: 2019のみ -->
      <div v-if="isApp2019" class="grid result-grid">
        <div class="grid-cell result-cell">
          <div>選択科目</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div>{{resultJson.total.select}} / {{specBorder.selectTotal}}</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="required" :style="getJudgementStyle(selectTotalJudgementValue)">{{selectTotalJudgementValue}}</div>
        </div>
      </div>

      <!-- MEMO: 2018のみ -->
      <div v-if="isApp2018" class="grid">
        <div class="grid-cell result-cell">
          <div>自由科目</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div>{{resultJson.total.free}} / {{specBorder.freeTotal}}</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="free" :style="getJudgementStyle(freeTotalJudgmentValue)">{{freeTotalJudgmentValue}}</div>
        </div>
      </div>
      <!-- MEMO: 2018-2019 -->
      <div class="grid result-grid">
        <div class="grid-cell result-cell">
          <div>合計単位数</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div>{{resultJson.total.total}} / {{specBorder.total}}</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="total" :style="getJudgementStyle(totalJudgmentValue)">{{totalJudgmentValue}}</div>
        </div>
      </div>
      <!-- MEMO: 2018-2019 -->
      <div class="grid">
        <div class="grid-cell result-cell">
          <div>総合判定</div>
        </div>
        <div class="grid-cell result-cell centering">
          <div></div>
        </div>
        <div class="grid-cell result-cell centering">
          <div id="graduate" :style="getJudgementStyle(graduateJudgmentValue)">{{graduateJudgmentValue}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'migiue',
  computed: {
    ...mapState([
      'resultJson',
      'specBorder',
    ]),
    aboveTotal () { return (this.resultJson.total.total >= this.specBorder.total) },
    aboveFreeTotal () { return (this.resultJson.total.free >= this.specBorder.freeTotal) && this.resultJson.smallestUnitPassed.freeResult },
    aboveRequiredTotal () { return (this.resultJson.total.total - this.resultJson.total.free >= this.specBorder.total - this.specBorder.freeTotal) && this.resultJson.smallestUnitPassed.mustSelectResult },
    // 2019
    aboveMustTotal () { return (this.resultJson.total.must >= this.specBorder.mustTotal)},
    aboveSelectTotal () { return (this.resultJson.total.select >= this.specBorder.selectTotal)},
    
    ableGraduate () {
      return this.aboveTotal && 
        this.aboveFreeTotal && 
        this.aboveRequiredTotal && 
        this.resultJson.smallestUnitPassed.freeResult &&
        this.resultJson.smallestUnitPassed.mustSelectResult
        && this.resultJson.categoryAllPassed
      },
    totalJudgmentValue () { return this.aboveTotal ? 'OK' : 'NG' },
    freeTotalJudgmentValue () { return this.aboveFreeTotal ? 'OK' : 'NG' },
    requiredTotalJudgementValue () { return this.aboveRequiredTotal ? 'OK' : 'NG'},
    graduateJudgmentValue () { return this.ableGraduate ? 'OK' : 'NG' },
    isApp2018 () { return process.env.VUE_APP_YEAR === '2018'},
    isApp2019 () { return process.env.VUE_APP_YEAR === '2019'},

    // 2019
    selectTotalJudgementValue () {return this.aboveSelectTotal ? 'OK' : 'NG'},
    mustTotalJudgementValue () {return this.aboveMustTotal ? 'OK' : 'NG'}
  },
  methods: {
    getJudgementStyle ( label ) {
      return label === 'OK' ? { color: 'blue'} : { color: 'red'}
    }
  }
}
</script>

<style>

</style>
